/**
 * check if element exists
 * @param {dom-element} el
 *
 * @return {boolean}
 */
export function getElementExists(el) {
  return el && typeof el !== 'undefined' && el !== null;
}

/**
 * get parent element by classname
 * @param {dom-element} el
 * @param {string} cls
 *
 * @return {dom-element} el
 */
export function getParentByClass(el, cls) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== 'undefined' && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    !el.classList.contains(cls)
  );
  return el;
}

/**
 * get parent element by data attribute
 * @param {dom-element} el
 * @param {string} attribute
 *
 * @return {dom-element} el
 */
export function getParentByDataAttribute(el, attribute) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== 'undefined' && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    !el.hasAttribute(attribute)
  );
  return el;
}

/**
 * Gets the parent of an element by tag
 *
 * @param  {dom-element} el
 * @param  {string} tagName
 * @return {dom-element}
 */
export function getParentByTag(el, tagName) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== 'undefined' && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.tagName.toLowerCase() != tagName.toLowerCase()
  );
  return el;
}

/**
 * Gets the parent of an element by ID
 *
 * @param  {dom-element} el
 * @param  {string} id
 * @return {dom-element}
 */
export function parentById(el, id) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== 'undefined' && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.id != id
  );
  return el;
}

/**
 * Gets the parent of an element by attribute-value
 *
 * @param  {dom-element} el
 * @param  {string} attr
 * @param  {string} value
 * @return {dom-element}
 */
export function parentByAttributeValue(el, attr, value) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== 'undefined' && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.getAttribute(attr) != value
  );
  return el;
}

/**
 * IE10 classList support
 * Method that checks whether cls is present in element object.
 * @param  {Object} ele DOM element which needs to be checked
 * @param  {Object} cls Classname is tested
 * @return {Boolean} True if cls is present, false otherwise.
 */
export function hasClass(ele, cls) {
  const classes = ele.getAttribute('class');
  if (classes == null) return false;
  const clsPos = classes.indexOf(cls);
  return (
    ele.hasAttribute('class') &&
    clsPos > -1 &&
    (classes.length == (clsPos + cls.length) || classes.substr(clsPos + cls.length, 1) == ' ')
  );
}

/**
 * Method that adds a class to given element.
 * @param  {Object} ele DOM element where class needs to be added
 * @param  {Object} cls Classname which is to be added
 * @return {null} nothing is returned.
 */
export function addClass(ele, cls) {
  if (!!ele) {
    if (ele.classList) {
      ele.classList.add(cls);
    } else if (!hasClass(ele, cls)) {
      ele.setAttribute('class', ele.getAttribute('class') + ' ' + cls);
    }
  }
}

/**
 * Method that does a check to ensure that class is removed from element.
 * @param  {Element} ele DOM element where class needs to be removed
 * @param  {Object} cls Classname which is to be removed
 * @return {null} Null nothing is returned.
 */
export function removeClass(ele, cls) {
  if (!!ele) {
    if (ele.classList) {
      ele.classList.remove(cls);
    } else if (hasClass(ele, cls)) {
      ele.setAttribute('class', ele.getAttribute('class').replace(cls, " "));
    }
  }
}

/**
 * get Element offset in page
 * @param {Element} el
 * @return {Object}
 * Access: el.left, el.top
 */
export function getOffset(el) {
  var _top = 0;
  var _left = 0;
  var _bottom = 0;
  var _right = 0;

  var _height = el.offsetHeight;
  var _width = el.offsetWidth;

  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _top += el.offsetTop - el.scrollTop;
    _left += el.offsetLeft - el.scrollLeft;

    el = el.offsetParent;
  }

  _bottom = _top + _height;
  _right = _left + _width;

  return {
    top: _top,
    left: _left,
    bottom: _bottom,
    right: _right,
  };
}

/**
 * Insert elemente after reference element
 * @param {int} newElement
 * @param {int} referenceElement
 */
export function insertAfter(newElement, referenceElement) {
  referenceElement.parentNode.insertBefore(
    newElement,
    referenceElement.nextSibling
  );
}

/**
 * Insert elemente before reference element
 * @param {int} newElement
 * @param {int} referenceElement
 */
export function insertBefore(newElement, referenceElement) {
  referenceElement.parentNode.insertBefore(newElement, referenceElement);
}

export function handleAjaxRequest(options) {
  if (!options.hasOwnProperty('type')) {
    options.type = 'get';
  }
  if (!options.hasOwnProperty('dataType')) {
    options.dataType = 'json';
  }
  if (!options.hasOwnProperty('data')) {
    options.data = {};
  }
  if (!options.hasOwnProperty('contentType')) {
    options.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
  }
  if (!options.hasOwnProperty('processData')) {
    options.processData = true;
  }
  $.ajax({
    type: options.type,
    url: options.url,
    data:
      options.contentType == 'application/json'
        ? JSON.stringify(options.data)
        : options.data,
    dataType: options.dataType,
    contentType: options.contentType,
    processData: options.processData,
    headers: {
      'XSRF-TOKEN': $('input[name="__RequestVerificationToken"]').val(),
    },
    success: (response, status, jqXHR) => {
      if (options.success && typeof options.success === 'function') {
        options.success(response, status, jqXHR);
      }
    },
    error: (error) => {
      if (options.error && typeof options.error === 'function') {
        options.error(error);
      }
    },
  });
}

/**
 * submits a form like it was submitted by user
 * also fires the "onsubmit" event, which is not fired if the form is submitted by form.submit()
 * https://stackoverflow.com/a/18072246/1652205
 * @param {Element} form
 */
export function submitForm(form) {
  //get the form element's document to create the input control with
  //(this way will work across windows in IE8)
  var button = form.ownerDocument.createElement('input');
  //make sure it can't be seen/disrupts layout (even momentarily)
  button.style.display = 'none';
  //make it such that it will invoke submit if clicked
  button.type = 'submit';
  //append it and click it
  form.appendChild(button).click();
  //if it was prevented, make sure we don't get a build up of buttons
  form.removeChild(button);
}

/**
 * Delay the given callback function for the number of milliseconds defined in ms
 * @param {function} callback function which is called delayed
 * @param {int} ms delay time in milliseconds
 */
export function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}
